export const GET_MULTIPLE_COUNTRY_LIST = "GET_MULTIPLE_COUNTRY_LIST"
export const GET_MULTIPLE_COUNTRY_LIST_SUCCESS = "GET_MULTIPLE_COUNTRY_LIST_SUCCESS"
export const CHANGE_MULTIPLE_COUNTRY_LIST = "CHANGE_MULTIPLE_COUNTRY_LIST"